<template>
    <div :data-component="$options.name">
        <cs-tabs
            v-model="modelValue"
            :options="options"
        >
            <template #link>
                <cs-link
                    v-if="propsByNewsType.link && propsByNewsType.link.children"
                    :href="propsByNewsType.link.href"
                    :target="propsByNewsType.link.target"
                    :rel="propsByNewsType.link.rel"
                >
                    {{ propsByNewsType.link.children[0].text }}
                </cs-link>
            </template>
            <div class="grid grid-cols-1 gap-16 mt-24 screen-m:gap-24 screen-l:grid-cols-3 screen-m:grid-cols-2">
                <cs-news-card
                    v-for="item in news"
                    v-show="showItem(item)"
                    :key="item.key"
                    :link="item.link"
                    :trackingData="createNewsTracking(item)"
                >
                    <template #caption>
                        <span>{{ item.caption }}</span></template
                    >
                    <template #headline>
                        <ms-headline type="h3">
                            {{ item.headline }}
                        </ms-headline>
                    </template>
                    <template #text>
                        <span>{{ item.text }}</span>
                    </template>
                    <template #linkText>
                        <span>{{ item.linkText }}</span></template
                    >
                    <template #icon>
                        <component
                            :is="propsByNewsType.iconComponentName"
                            class="w-24 h-24"
                        />
                    </template>
                </cs-news-card>
            </div>
        </cs-tabs>
    </div>
</template>
<script lang="ts" src="./HydratedNewsTabs.ts" />
